/**
 * V2QsRange 컴포넌트 Props 인터페이스
 * V1 QsInputRange의 V2 버전 (순수 UI만)
 *
 * 슬라이더 (Range) 입력 컴포넌트
 */

export interface V2QsRangeProps {
  /**
   * 현재 값
   */
  value?: number;

  /**
   * 값 변경 시 콜백
   */
  onChange?: (value: number) => void;

  /**
   * 최소값 (기본: 0)
   */
  min?: number;

  /**
   * 최대값 (기본: 10)
   */
  max?: number;

  /**
   * 스텝 (기본: 1)
   */
  step?: number;

  /**
   * 틱 마크 표시 여부 (기본: true)
   */
  showTicks?: boolean;

  /**
   * 현재 값 표시 여부 (기본: false)
   */
  showValue?: boolean;

  /**
   * 비활성화 여부
   */
  disabled?: boolean;

  /**
   * 읽기 전용 여부
   */
  readOnly?: boolean;

  /**
   * 에러 상태
   */
  hasError?: boolean;

  /**
   * 에러 메시지
   */
  errorMessage?: string;

  /**
   * 스케일 라벨 (특정 값에 라벨 표시)
   * 예: [{ value: 0, text: '전혀 그렇지 않음' }, { value: 5, text: '매우 그러함' }]
   */
  labels?: Array<{ value: number; text: string }>;

  /**
   * 추가 CSS 클래스
   */
  className?: string;

  /**
   * 슬라이더 추가 CSS 클래스
   */
  sliderClassName?: string;
}

export const defaultV2QsRangeProps: Partial<V2QsRangeProps> = {
  min: 0,
  max: 10,
  step: 1,
  showTicks: true,
  showValue: false,
  disabled: false,
  readOnly: false,
  hasError: false,
};
